import { type CheckboxDescriptionProps, Description } from "./Description";
import { type CheckboxLabelProps, Label } from "./Label";
import { type CheckboxRootProps, Root } from "./Root";

export const Checkbox = {
  Root,
  Label,
  Description,
};

export const CheckboxRoot = Root;
export const CheckboxLabel = Label;
export const CheckboxDescription = Description;

export type { CheckboxDescriptionProps, CheckboxLabelProps, CheckboxRootProps };
